/**
 * Settings → Credit Report（个人）。
 * 打开页面打 STATSIG.COMMON.VIEW，value=settings_credit_report；Management 同组件 value=mgmt_credit_report。
 *
 * 正在用：Soft / Hard 可连多个个人账号；Connect new account / Edit → Connect；
 * Remove；Soft tab Allow borrower to initiate soft credit pull；Set as default；切 tab。
 * 已不算：Cancel、公司锁账号。
 * Management Team Credit Report 是另一页（TEAM_CREDIT_REPORT），不复用。
 */
export enum SettingsPersonalCreditReportEvent {
    /**
     * 切换 Soft / Hard tab。
     * value 与 metadata.tab 相同：soft_pull|hard_pull
     */
    TAB = 'CREDIT_REPORT_TAB',
    /**
     * Connect new account：弹窗点 Connect 落库。
     * 属性 type=soft_pull|hard_pull
     */
    CONNECT_NEW_ACCOUNT = 'CREDIT_REPORT_CONNECT_NEW_ACCOUNT',
    /**
     * Edit 后弹窗点 Connect。
     * 属性 type=soft_pull|hard_pull
     */
    UPDATE = 'CREDIT_REPORT_UPDATE',
    /**
     * 删除账号。
     * 属性 type=soft_pull|hard_pull
     */
    REMOVE = 'CREDIT_REPORT_REMOVE',
    /**
     * Allow borrower to initiate soft credit pull。
     * 属性 enabled=true|false
     */
    ALLOW_SOFT_PULL_SWITCH = 'CREDIT_REPORT_ALLOW_SOFT_PULL_SWITCH',
    /**
     * Set as default。
     * 属性 type=soft_pull|hard_pull
     */
    SET_AS_DEFAULT = 'CREDIT_REPORT_SET_AS_DEFAULT',
}
